/* global clientParamBuilder */
import { isNil, isEmpty } from "ramda";
import Cookies from "js-cookie";

import FetchHelpers from "utils/FetchHelpers";
import UserPresenter from "presenters/UserPresenter";
import { jjLogger } from "utils/logUtils";

export default {
  post(currentUser, event) {
    if (!window.clientParamBuilder) {
      jjLogger.logError(
        "FacebookConversionRepository.js: post() - clientParamBuilder is not defined and event wont be sent",
      );
      return;
    }

    clientParamBuilder.processAndCollectParams(window.location.href);

    const fbp = clientParamBuilder.getFbp();
    const fbc = clientParamBuilder.getFbc();

    jjLogger.log(`FacebookConversionRepository.js: post() ${event.event_name} | fbp: ${fbp} | fbc: ${fbc}`);

    const testEventCode = Cookies.get("test_event_code");

    if (process.env.DEPLOY_ENV !== "production" && isNil(testEventCode)) return;

    let payload = {
      action_source: "website",
      user_data: {
        client_user_agent: navigator.userAgent,
        fbp,
      },
    };

    if (UserPresenter.isRegistered(currentUser)) {
      payload.user_data.em = clientParamBuilder.getNormalizedAndHashedPII(currentUser.email, "email");
    }

    const userId = UserPresenter.id(currentUser);
    if (!isNil(userId) && !isEmpty(userId)) {
      payload.user_data.external_id = userId;
    }

    payload = { ...payload, ...event };

    if (!isNil(fbc) && !isEmpty(fbc)) {
      payload.user_data.fbc = fbc;
    }

    if (!isNil(testEventCode)) {
      payload.test_event_code = testEventCode;
    }

    FetchHelpers.post(process.env.FACEBOOK_CONVERSION_API, payload);
  },
};
